/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForGitHubPersonalAccessTokenProtocol extends models.ServiceAccountCredentialsBaseForGitHub {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForGitHubPersonalAccessTokenProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForGitHubPersonalAccessTokenProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForGitHubPersonalAccessTokenProtocol>): ServiceAccountCredentialsForGitHubPersonalAccessTokenProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsForGitHubPersonalAccessTokenProtocol(), model);
        ServiceAccountCredentialsForGitHubPersonalAccessTokenProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForGitHubPersonalAccessTokenProtocol>): ServiceAccountCredentialsForGitHubPersonalAccessTokenProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsForGitHubPersonalAccessTokenProtocol.newInstance(<ServiceAccountCredentialsForGitHubPersonalAccessTokenProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForGitHubPersonalAccessTokenProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsForGitHubPersonalAccessTokenProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForGitHubPersonalAccessTokenProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForGitHub.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForGitHubPersonalAccessTokenProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Personal Access Token. This is a required Field.
     */
    access_token: string;

}
